import React, { useState, useEffect, useRef } from "react";
import styles from "./Invoice.module.css";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { toCommas } from "../../utils/utils";
import { useSnackbar } from 'react-simple-snackbar';
import IconButton from "@material-ui/core/IconButton";
import DeleteOutlineRoundedIcon from "@material-ui/icons/DeleteOutlineRounded";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles, alpha } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import InputBase from "@material-ui/core/InputBase";
import { Container, Grid } from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import Divider from "@material-ui/core/Divider";
import SaveIcon from "@material-ui/icons/Save";
import Button from "@material-ui/core/Button";
import Chip from "@material-ui/core/Chip";
import { initialState } from "../../initialState";
import currencies from "../../currencies.json";
import {
  createInvoice,
  getInvoice,
  updateInvoice,
} from "../../actions/invoiceActions";
import { getClientsByUser } from "../../actions/clientActions";
import { getProductsByUser } from "../../actions/productActions";
import { getLockupsByUser, updateLockup } from "../../actions/lockupActions";
import { getInventoriesByUser, updateInventory } from "../../actions/inventoryActions";
import { fetchPcModelInventory, updateQuote } from "../../api";
import AddClient from "./AddClient";
import InvoiceType from "./InvoiceType";
import AddProduct from "../Products/AddProduct";
import axios from "axios";
import { useLocation } from "react-router-dom";
import {Checkbox, FormGroup, FormControlLabel} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  large: {
    width: theme.spacing(12),
    height: theme.spacing(12),
  },
  table: {
    minWidth: 650,
  },

  headerContainer: {
    // display: 'flex'
    paddingTop: theme.spacing(1),
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(1),
  },
}));

const PC_PRIORITY_KEYS = [
  'model',
  'modelNumber',
  'description',
  'desc',
  'quantity',
  'qty',
  'available',
  'onHand',
  'store',
  'location',
  'price',
  'cost',
  'status',
]

const formatPcKey = (key = '') =>
  String(key)
    .replace(/[_-]+/g, ' ')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/\b\w/g, (letter) => letter.toUpperCase())

const formatPcValue = (value) => {
  if (value === null || value === undefined || value === '') return 'N/A'
  if (typeof value === 'object') return JSON.stringify(value)
  return String(value)
}

const getPcInventoryRows = (payload) => {
  if (!payload) return []
  if (Array.isArray(payload)) return payload
  if (typeof payload !== 'object') return [{ result: payload }]

  const knownArrayKeys = ['data', 'results', 'items', 'rows', 'inventory', 'records']
  for (const key of knownArrayKeys) {
    if (Array.isArray(payload[key])) return payload[key]
  }

  const nestedArray = Object.values(payload).find((value) => Array.isArray(value))
  if (nestedArray) return nestedArray
  return [payload]
}

const getPcDisplayPairs = (row = {}) => {
  if (!row || typeof row !== 'object' || Array.isArray(row)) {
    return [['Result', formatPcValue(row)]]
  }

  const entries = Object.entries(row).filter(([, value]) => value !== null && value !== undefined && value !== '')
  const normalizedEntries = entries.map(([key, value]) => ({ key, value, normalizedKey: key.toLowerCase().replace(/[^a-z0-9]/g, '') }))
  const priorityPairs = PC_PRIORITY_KEYS
    .map((priorityKey) => normalizedEntries.find((entry) => entry.normalizedKey === priorityKey.toLowerCase().replace(/[^a-z0-9]/g, '')))
    .filter(Boolean)

  const selected = priorityPairs.length ? priorityPairs : normalizedEntries.slice(0, 6)
  return selected.slice(0, 6).map(({ key, value }) => [formatPcKey(key), formatPcValue(value)])
}

const Invoice = () => {
  const location = useLocation();
  const [invoiceData, setInvoiceData] = useState(initialState);
  const [product, setProduct] = useState(null)
  const [lockup, setLockup] = useState(null)
  const [dno, setDno] = useState(null);
  const [rates, setRates] = useState(0.00);
  const [deliveryFee, setDeliveryFee] = useState(10.00);
  const [deliveryCost, setDeliveryCost] = useState(0.00);
  const [deliveryFeeOverride, setDeliveryFeeOverride] = useState(false);
  const [salesTax, setSalesTax] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const [total, setTotal] = useState(0);
  const [selectedRbDate, setSelectedRbDate] = useState(
    moment().add(1, 'days')
  );
  const [selectedDate, setSelectedDate] = useState(
    moment(selectedRbDate).add(1, 'days')
  );
  const [client, setClient] = useState(null);
  const [openSnackbar, closeSnackbar] = useSnackbar()
  const [type, setType] = useState("Invoice");
  const [status, setStatus] = useState("");
  const [productModalOpen, setProductModalOpen] = useState(false);
  const [productCurrentId, setProductCurrentId] = useState(null);
  const [pcLookupByModel, setPcLookupByModel] = useState({});
  const [pcLookupLoadingByModel, setPcLookupLoadingByModel] = useState({});
  const { id } = useParams();
  const isEditingInvoice = Boolean(id);
  const clients = useSelector((state) => state.clients.clients);
  const products = useSelector((state) => state.products.products);
  const lockups = useSelector((state) => state.lockups.lockups);
  const inventories = useSelector((state) => state.inventories.inventories)
  const { invoice } = useSelector((state) => state.invoices);
  const dispatch = useDispatch();
  const history = useHistory();
  const user = JSON.parse(localStorage.getItem("profile"));
  const originalItems = useRef(invoice ? invoice.items : [
      {modelNumber: '', unitPrice: '', quantity: '', discount: '', unitCost: '', doNotOrder: false, lockup: false},
  ]);
  console.log(originalItems)
  const originalQuantity = useRef('');
  const quoteDraftAppliedRef = useRef(false);
  const quoteDraftQuoteIdRef = useRef(null);
  useEffect(() => {
    getTotalCount();
    // eslint-disable-next-line
  }, [location]);

  const getTotalCount = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API}/invoices/count?searchQuery=${user?.result?._id}`
      );
      //   console.log(response.data);
      //Get total count of invoice from the server and increment by one to serialized numbering of invoice
      setInvoiceData((prevState) => ({
        ...prevState,
        invoiceNumber: (Number(response.data) + 1).toString().padStart(3, "0"),
      }));
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (id){
      dispatch(getInvoice(id));
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    dispatch(
      getClientsByUser({ search: user?.result._id || user?.result?.googleId })
    );
    dispatch(
      getProductsByUser({ search: user?.result._id || user?.result?.googleId })
    );
    dispatch(
      getLockupsByUser({ search: user?.result._id || user?.result?.googleId })
    );
    dispatch(
      getInventoriesByUser({ search: user?.result._id || user?.result?.googleId })
    );
    // eslint-disable-next-line
  }, [dispatch]);


  useEffect(() => {
    if (isEditingInvoice || quoteDraftAppliedRef.current) return;
    const quoteDraft = location.state?.quoteDraft;
    if (!quoteDraft) return;

    quoteDraftAppliedRef.current = true;
    quoteDraftQuoteIdRef.current = quoteDraft.quoteId || null;

    const draftItems = Array.isArray(quoteDraft.items) && quoteDraft.items.length
      ? quoteDraft.items
      : initialState.items;
    const draftType = quoteDraft.type || 'Quotation';
    const draftStatus = quoteDraft.status || 'Unpaid';
    const draftDeliveryFee = Number(quoteDraft.deliveryFee) || 0;
    const draftDeliveryFeeOverride = Boolean(quoteDraft.deliveryFeeOverride || draftDeliveryFee > 0);
    const draftClient = quoteDraft.client || (quoteDraft.shipTo ? {
      store: quoteDraft.shipTo.name || quoteDraft.shipTo.shippingAddress || 'Pasted quote address',
      name: quoteDraft.shipTo.name || 'Pasted quote address',
      address: [
        quoteDraft.shipTo.shippingAddress,
        quoteDraft.shipTo.shippingCity,
        quoteDraft.shipTo.shippingState,
        quoteDraft.shipTo.shippingZip,
      ].filter(Boolean).join(', '),
    } : null);

    setInvoiceData((prev) => ({
      ...prev,
      type: draftType,
      status: draftStatus,
      items: draftItems,
      notes: quoteDraft.notes || prev.notes,
      deliveryFee: quoteDraft.deliveryFee ?? prev.deliveryFee,
      deliveryFeeOverride: draftDeliveryFeeOverride,
      client: draftClient || prev.client,
    }));
    setType(draftType);
    setStatus(draftStatus);
    if (draftClient) setClient(draftClient);
    if (quoteDraft.deliveryFee !== undefined && quoteDraft.deliveryFee !== null) setDeliveryFee(draftDeliveryFee);
    setDeliveryFeeOverride(draftDeliveryFeeOverride);
    if (quoteDraft.receivedByDate) {
      const receivedByDate = moment(quoteDraft.receivedByDate);
      if (receivedByDate.isValid()) {
        setSelectedRbDate(receivedByDate);
        setSelectedDate(moment(receivedByDate).add(1, 'days'));
      }
    }
  }, [isEditingInvoice, location.state]);

  useEffect(() => {
    if (invoice) {
      //Automatically set the default invoice values as the ones in the invoice to be updated
      setInvoiceData(invoice);
      setRates(invoice.rates);
      setClient(invoice.client);
      setType(invoice.type);
      setStatus(invoice.status);
      setSelectedDate(invoice.dueDate);
      setSelectedRbDate(invoice.receivedByDate);
      setDeliveryFee(typeof invoice.deliveryFee === 'number' ? invoice.deliveryFee : 0);
      setDeliveryCost(typeof invoice.deliveryCost === 'number' ? invoice.deliveryCost : 0);
      setDeliveryFeeOverride(Boolean(invoice.deliveryFeeOverride));
    }
  }, [invoice]);

  useEffect(() => {
    if (type === "Receipt") {
      setStatus("Paid");
    } else {
      setStatus("Unpaid");
    }
  }, [type]);

  const formatDollarsToCents = function (value) {
    value = `${value}`.replace(/[^\d.-]/g, '');
    if (value && value.includes('.')) {
        value = value.substring(0, value.indexOf('.') + 3);
    }

    return value ? Math.round(parseFloat(value) * 100) : 0;
};

const formatCentsToDollars = function (value) {
    value = `${value}`.replace(/[^\d.-]/g, '');
    value = parseFloat(value);
    return value ? value / 100 : 0;
};

// Create our number formatter.
const dollar_formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
});

  const applyInventoryOverride = (index, inventoryItem = null) => {
    setInvoiceData((prevState) => {
      const values = [...prevState.items];
      const row = { ...(values[index] || {}) };
      const productFallback = products.find((obj) => obj.modelNumber === row.modelNumber);

      row.doNotOrder = true;
      row.lockup = false;
      row.inventoryOverride = true;
      if (inventoryItem) {
        row.unitPrice = formatCentsToDollars(inventoryItem.price);
        row.unitCost = formatCentsToDollars(inventoryItem.cost);
        setDno(inventoryItem);
      } else if (productFallback) {
        row.unitPrice = formatCentsToDollars(productFallback.price);
        row.unitCost = formatCentsToDollars(productFallback.cost);
      }

      values[index] = row;
      return { ...prevState, items: values };
    });
    closeSnackbar();
  };

  const openInventoryOverrideSnackbar = (message, index, inventoryItem = null) => {
    openSnackbar(
      <span
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          width: "100%",
          flexWrap: "wrap",
        }}
      >
        <span style={{ flex: "1 1 220px" }}>{message}</span>
        <button
          type="button"
          onClick={() => applyInventoryOverride(index, inventoryItem)}
          style={{
            border: "1px solid rgba(255, 255, 255, 0.85)",
            borderRadius: 4,
            background: "transparent",
            color: "#fff",
            cursor: "pointer",
            padding: "6px 10px",
            fontWeight: 600,
          }}
        >
          Override
        </button>
      </span>,
      10000
    );
  };

  const defaultProps = {
    options: currencies,
    getOptionLabel: (option) => option.label,
  };

  const clientsProps = {
    options: clients,
    getOptionLabel: (option) => option.store,
  };

  const productsProps = {
    options: products,
    getOptionLabel: (option) => option.modelNumber,
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleRbDateChange = (date) => {
    setSelectedRbDate(date);
    setPcLookupByModel({});
    let days = client ? client.term : 1;
    let tomorrow = moment(date).add(days, 'days');
    setSelectedDate(tomorrow);
  };

  const handleRates = (e) => {
    setRates(e.target.value);
    setInvoiceData((prevState) => ({ ...prevState, tax: e.target.value }));
  };

  const handleDeliveryFeeChange = (e) => {
    let value = 0
    if (e.target.value && e.target.value !== '') {
      value = parseInt(e.target.value)
    }
    setDeliveryFee(value)
    
    setInvoiceData((prevState) => ({ ...prevState, deliveryFee: value}));
  }

  const handleDeliveryFeeOverride = (e) => {
    const checked = e.target.checked
    setDeliveryFeeOverride(checked);
    if (!checked) {
      setDeliveryCost(0)
      setInvoiceData((prevState) => ({ ...prevState, deliveryFeeOverride: checked, deliveryCost: 0 }));
      return
    }
    setInvoiceData((prevState) => ({ ...prevState, deliveryFeeOverride: checked }));
  }

  const handleDeliveryCostChange = (e) => {
    let value = 0
    if (e.target.value && e.target.value !== '') {
      value = parseFloat(e.target.value)
    }
    setDeliveryCost(value)
    setInvoiceData((prevState) => ({ ...prevState, deliveryCost: value }))
  }

  const handleDoNotOrderClick = (index, e) => {
    const values = [...invoiceData.items];
    values[index][e.target.name] = e.target.checked;
    if (values[index]['lockup'] === true) {
      values[index][e.target.name] = !e.target.checked;
      e.target.checked = false;
      openSnackbar('Deselect lockup to select inventory.')
    } else {
      if (e.target.checked) {
          let inv = inventories.find(obj => {
            if (obj.modelNumber === values[index]['modelNumber']) {
              if (obj.quantity < values[index]['quantity']) {
                openInventoryOverrideSnackbar(`There are only ${obj.quantity} ${obj.modelNumber} in inventory.`, index, obj)
                values[index][e.target.name] = !e.target.checked;
                e.target.checked = false;
              } else {
                values[index]['unitPrice'] = formatCentsToDollars(obj.price);
                values[index]['unitCost'] = formatCentsToDollars(obj.cost);
                values[index]['inventoryOverride'] = false;
                setDno(obj);
              }
              return true;
            } else {
              return false;
            }
          })
          if (inv === undefined) {
              openInventoryOverrideSnackbar(`${values[index]['modelNumber']} is not in inventory.`, index)
              values[index][e.target.name] = !e.target.checked;
              e.target.checked = false;
          }
      } else {
        values[index]['inventoryOverride'] = false;
        products.find(obj => {
          if (obj.modelNumber === values[index]['modelNumber']) {
            values[index]['unitPrice'] = formatCentsToDollars(obj.price);
            values[index]['unitCost'] = formatCentsToDollars(obj.cost);
            return true;
          } else {
            return false;
          }
        })
      }
    }
    setInvoiceData({...invoiceData, items: values})
  }

  const handleLockupClick = (index, e) => {
    const values = [...invoiceData.items];
    values[index][e.target.name] = e.target.checked;
    if (values[index]['doNotOrder'] === true) {
      values[index][e.target.name] = !e.target.checked;
      values[index]['inventoryOverride'] = false;
      e.target.checked = false;
      openSnackbar('Deselect inventory to select lockup.')
    } else {
      if (e.target.checked) {
        let l = lockups.find(obj => {
          if (obj.modelNumber === values[index]['modelNumber']) {
            if (obj.quantity < values[index]['quantity']) {
              openSnackbar(`There are only ${obj.quantity} ${obj.modelNumber} in lockup.`)
              values[index][e.target.name] = !e.target.checked;
              e.target.checked = false;
            } else {
              values[index]['unitPrice'] = formatCentsToDollars(obj.price);
              values[index]['unitCost'] = formatCentsToDollars(obj.cost);
              setLockup(obj);
            }
            return true;
          } else {
            return false;
          }
        })
        if (l === undefined) {
            openSnackbar(`${values[index]['modelNumber']} is not in lockup.`)
            values[index][e.target.name] = !e.target.checked;
            e.target.checked = false;
        }
    } else {
      products.find(obj => {
        if (obj.modelNumber === values[index]['modelNumber']) {
          values[index]['unitPrice'] = formatCentsToDollars(obj.price);
          values[index]['unitCost'] = formatCentsToDollars(obj.cost);
          return true;
        } else {
          return false;
        }
      })
    }
    }
    setInvoiceData({...invoiceData, items: values})
  }

  const lookupPcModelInventory = async (modelNumber) => {
    const normalizedModel = String(modelNumber || '').trim().toUpperCase()
    if (!normalizedModel || pcLookupLoadingByModel[normalizedModel]) return

    setPcLookupLoadingByModel((prev) => ({ ...prev, [normalizedModel]: true }))
    try {
      const receiveByDate = selectedRbDate ? moment(selectedRbDate).format('YYYY-MM-DD') : ''
      const { data } = await fetchPcModelInventory(normalizedModel, receiveByDate)
      setPcLookupByModel((prev) => ({
        ...prev,
        [normalizedModel]: {
          data,
          error: null,
          checkedAt: new Date().toISOString(),
        },
      }))
    } catch (error) {
      const message = error?.response?.data?.message || 'PC Richard inventory lookup failed'
      setPcLookupByModel((prev) => ({
        ...prev,
        [normalizedModel]: {
          data: null,
          error: message,
          checkedAt: new Date().toISOString(),
        },
      }))
      openSnackbar(message)
    } finally {
      setPcLookupLoadingByModel((prev) => ({ ...prev, [normalizedModel]: false }))
    }
  }

  const renderPcLookupSummary = (modelNumber) => {
    const normalizedModel = String(modelNumber || '').trim().toUpperCase()
    if (!normalizedModel) return null

    if (pcLookupLoadingByModel[normalizedModel]) {
      return <div className={styles.pcInventoryLookup}>Checking PC inventory...</div>
    }

    const lookup = pcLookupByModel[normalizedModel]
    if (!lookup) {
      return (
        <div className={styles.pcInventoryLookup}>
          <div className={styles.pcInventoryHeader}>PC Richard</div>
          <Button
            color="primary"
            size="small"
            type="button"
            variant="outlined"
            style={{ textTransform: 'none' }}
            onClick={() => lookupPcModelInventory(normalizedModel)}
          >
            Check PC inventory
          </Button>
        </div>
      )
    }

    if (lookup.error) {
      return <div className={`${styles.pcInventoryLookup} ${styles.pcInventoryError}`}>{lookup.error}</div>
    }

    const summary = lookup.data?.inventorySummary
    const inventoryStatus = lookup.data?.inventoryStatus || lookup.data?.data?.inventoryStatus || 'Not provided'
    if (summary?.stores) {
      const lookupStatus = lookup.data?.onOrderLookupStatus || 'not checked'
      const lookupChecked = lookupStatus === 'checked'
      return (
        <div className={styles.pcInventoryLookup}>
          <div className={styles.pcInventoryHeader}>
            PC Richard inventory
          </div>
          <div className={styles.pcInventoryGrid}>
            <span><strong>Inventory Status:</strong> {inventoryStatus}</span>
            <span><strong>Available:</strong> {summary.totals?.balance ?? 0}</span>
            <span><strong>FD:</strong> {summary.totals?.farmingdaleQuantity ?? summary.totals?.quantity ?? 0}</span>
            <span><strong>NJ:</strong> {summary.totals?.njQuantity ?? summary.stores?.cartaret?.quantity ?? 0}</span>
            <span><strong>Sched:</strong> {summary.totals?.scheduled ?? 0}</span>
            <span><strong>Asap:</strong> {summary.totals?.asap ?? 0}</span>
            <span><strong>On Order:</strong> {summary.totals?.onOrder ?? 0}</span>
            <span>
              <strong>Lookup:</strong>
              <span className={styles.pcLookupValue}>
                <span className={styles.pcLookupDesktopValue}>{lookupStatus}</span>
                <span
                  className={`${styles.pcLookupMobileValue} ${
                    lookupChecked ? styles.pcLookupSuccess : styles.pcLookupMuted
                  }`}
                  title={lookupStatus}
                  aria-label={lookupStatus}
                >
                  {lookupChecked ? '✓' : 'X'}
                </span>
              </span>
            </span>
          </div>
        </div>
      )
    }

    const rows = getPcInventoryRows(lookup.data?.data)
    if (!rows.length) {
      return <div className={styles.pcInventoryLookup}>No PC inventory details returned.</div>
    }

    const displayPairs = getPcDisplayPairs(rows[0])

    return (
      <div className={styles.pcInventoryLookup}>
        <div className={styles.pcInventoryHeader}>
          PC Richard {rows.length > 1 ? `${rows.length} records` : 'inventory'}
        </div>
        <div className={styles.pcInventoryGrid}>
          <span><strong>Inventory Status:</strong> {inventoryStatus}</span>
          {displayPairs.map(([label, value]) => (
            <span key={`${normalizedModel}-${label}`}>
              <strong>{label}:</strong> {value}
            </span>
          ))}
        </div>
      </div>
    )
  }

  const getSelectedPcModels = () =>
    Array.from(new Set(
      (invoiceData.items || [])
        .map((item) => String(item?.modelNumber || '').trim().toUpperCase())
        .filter(Boolean)
    ))

  const getScheduledOnOrderRows = (selectedModels) =>
    selectedModels
      .flatMap((modelNumber) => pcLookupByModel[modelNumber]?.data?.onOrderRows || [])
      .sort((a, b) => moment(a.arrival, ['M/D/YY', 'M/D/YYYY']).valueOf() - moment(b.arrival, ['M/D/YY', 'M/D/YYYY']).valueOf())

  const renderScheduledOnOrderTable = () => {
    const selectedModels = getSelectedPcModels()
    const rows = getScheduledOnOrderRows(selectedModels)
    const lookups = selectedModels.map((modelNumber) => pcLookupByModel[modelNumber]).filter(Boolean)
    const hasCompletedLookup = lookups.some((lookup) => lookup?.data)
    if (!hasCompletedLookup) return null
    const modelsWithRows = new Set(rows.map((row) => String(row.modelNumber || '').trim().toUpperCase()))
    const checkedModelsWithoutRows = lookups
      .filter((lookup) => lookup?.data?.onOrderLookupStatus === 'checked')
      .map((lookup) => lookup.data?.modelNumber || 'Unknown model')
      .filter((modelNumber) => !modelsWithRows.has(String(modelNumber || '').trim().toUpperCase()))
    const skippedModels = lookups
      .filter((lookup) => lookup?.data?.onOrderLookupStatus === 'skipped-no-on-order')
      .map((lookup) => lookup.data?.modelNumber)
      .filter(Boolean)

    return (
      <div className={styles.pcOnOrderTable}>
        <div className={styles.pcOnOrderTitle}>Scheduled On Order</div>
        {rows.length ? (
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Model</th>
                <th>Location</th>
                <th>Qty</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, index) => (
                <tr key={`${row.modelNumber}-${row.arrival}-${row.locationNum}-${index}`}>
                  <td>{row.arrival}</td>
                  <td>{row.modelNumber}</td>
                  <td>{row.locationNum}</td>
                  <td>{row.planQty}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : null}
        {(checkedModelsWithoutRows.length || skippedModels.length) ? (
          <div className={styles.pcOnOrderEmpty}>
            {checkedModelsWithoutRows.map((modelNumber) => (
              <div key={modelNumber}>
                No scheduled deliveries found for {modelNumber}.
              </div>
            ))}
            {skippedModels.map((modelNumber) => (
              <div key={`skipped-${modelNumber}`}>
                No on-order lookup was needed for {modelNumber}.
              </div>
            ))}
          </div>
        ) : (
          rows.length ? null : <div className={styles.pcOnOrderEmpty}>No scheduled on-order details available.</div>
        )}
      </div>
    )
  }

  const handleProductChange = (index, e, value) => {
    setProduct(value);
    const values = [...invoiceData.items];
    if (value !== null) {
      values[index]['modelNumber'] = value.modelNumber;
      values[index]['unitPrice'] = formatCentsToDollars(value.price);
      values[index]['unitCost'] = formatCentsToDollars(value.cost);
      lookupPcModelInventory(value.modelNumber);
    } else {
      values[index]['modelNumber'] = '';
      values[index]['unitPrice'] = '';
      values[index]['unitCost'] = '';
    }
    setInvoiceData({ ...invoiceData, items: values });
  }

  const handleProductSaved = () => {
    const userId = user?.result?._id || user?.result?.googleId;
    if (userId) {
      dispatch(getProductsByUser({ search: userId }));
    }
  };

  const handleClientChange = (value) => {
    setClient(value);
    if (value) {
      let tempDueDate = moment(selectedRbDate).add(value.term, 'days');
      setSelectedDate(tempDueDate); 
    } else {
      let tempDueDate = moment(selectedRbDate).add(1, 'days');
      setSelectedDate(tempDueDate);
    }

  }

  // console.log(invoiceData)
  // Change handler for dynamically added input field
  const handleChange = (index, e) => {
    const values = [...invoiceData.items];
    values[index][e.target.name] = e.target.value;
    console.log(values);
    setInvoiceData({ ...invoiceData, items: values });
  };

  const handleQuantityChange = (index, e) => {
    const values = [...invoiceData.items];
    values[index][e.target.name] = e.target.value;
    if (values[index]['doNotOrder'] === true && values[index]['inventoryOverride'] === true) {
      setInvoiceData({ ...invoiceData, items: values });
      return;
    }
    if (values[index]['lockup'] === true || values[index]['doNotOrder'] === true) {
      let arr = values[index]['lockup'] ? lockups : inventories
      let str = values[index]['lockup'] ? 'lockup' : 'inventory'
      let l = arr.find(obj => {
        if (obj.modelNumber === values[index]['modelNumber']) {
          if (invoice) {
            let originalQty = (parseInt(obj.quantity)) + parseInt(originalItems.current[index]['quantity'])
            if ( originalQty < values[index]['quantity']) {
              openSnackbar(`There are only ${originalQty} ${obj.modelNumber} in ${str}.`)
              values[index][e.target.name] = originalItems.current[index]['quantity'];
            } else {
              values[index]['unitPrice'] = formatCentsToDollars(obj.price);
              values[index]['unitCost'] = formatCentsToDollars(obj.cost);
              values[index][e.target.name] = e.target.value;
            }
            return true;
          }
          else {
            if (obj.quantity < values[index]['quantity']) {
              openSnackbar(`There are only ${obj.quantity} ${obj.modelNumber} in ${str}.`)
              values[index][e.target.name] = originalItems.current[index]['quantity'];
            } else {
              values[index]['unitPrice'] = formatCentsToDollars(obj.price);
              values[index]['unitCost'] = formatCentsToDollars(obj.cost);
              values[index][e.target.name] = e.target.value;
            }
            return true;
          }
          
        } else {
          return false;
        }
      })
      if (l === undefined) {
          openSnackbar(`${values[index]['modelNumber']} is not in ${str}.`)
          values[index][e.target.name] = originalQuantity;
      }
    }
    setInvoiceData({ ...invoiceData, items: values });
  };


  const handlePriceChange = (index, e) => {
    const values = [...invoiceData.items];
    values[index][e.target.name] = e.target.value;
  }

  useEffect(() => {
    //Get the subtotal
    const subTotal = () => {
      var arr = document.getElementsByName("amount");
      var subtotal = 0;
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].value) {
          subtotal += +arr[i].value;
        }
        // document.getElementById("subtotal").value = subtotal;
        setSubTotal(subtotal);
      }
      const effectiveDeliveryFeeOverride = Boolean(deliveryFeeOverride || invoiceData?.deliveryFeeOverride);
      if (effectiveDeliveryFeeOverride) {
        const explicitDeliveryFee = Number(invoiceData?.deliveryFee);
        if (Number.isFinite(explicitDeliveryFee)) {
          setDeliveryFee(explicitDeliveryFee);
        }
        return;
      }

      const defaultDeliveryFee = subtotal < 2000 ? 10.00 : 0.00;
      setDeliveryFee(defaultDeliveryFee);
      if (invoiceData?.deliveryFee !== defaultDeliveryFee) {
        setInvoiceData((prevState) => ({ ...prevState, deliveryFee: defaultDeliveryFee }));
      }
    };

    subTotal();
  }, [invoiceData, deliveryFeeOverride]);

  useEffect(() => {
    if (!deliveryFeeOverride && deliveryCost !== 0) {
      setDeliveryCost(0)
      setInvoiceData((prevState) => ({ ...prevState, deliveryCost: 0 }))
    }
  }, [deliveryFeeOverride, deliveryCost])

  // useEffect(() => {
  //   if (client) {
  //     let tempDueDate = moment(selectedRbDate).add(client.term, 'days');
  //     setSelectedDate(tempDueDate); 
  //   } else {
  //     let tempDueDate = moment(selectedRbDate).add(1, 'days');
  //     setSelectedDate(tempDueDate);
  //   }
  // }, [client])

  useEffect(() => {
    const total = () => {
      //Tax rate is calculated as (input / 100 ) * subtotal + subtotal
      
      //VAT is calculated as tax rates /100 * subtotal
      let cents = formatDollarsToCents(subTotal);
      let totalTaxCents = (rates / 100) * cents;
      let totalTax = parseFloat(formatCentsToDollars(totalTaxCents).toFixed(2));
      const overallSum = totalTax + subTotal + deliveryFee;
      setSalesTax(totalTax);
      setTotal(overallSum);
    };
    total();
  }, [invoiceData, rates, subTotal, deliveryFee]);

  const handleAddField = (e) => {
    e.preventDefault();
    setInvoiceData((prevState) => ({
      ...prevState,
      items: [
        ...prevState.items,
        { modelNumber: "", unitPrice: "", quantity: "", amount: "", unitCost: "", discount: "", doNotOrder: false, lockup: false },
      ],
    }));
  };

  const handleRemoveField = (index) => {
    const values = invoiceData.items;
    values.splice(index, 1);
    if (values.length === 0) {
      setInvoiceData((prevState) => ({
        ...prevState,
        items: [
          { modelNumber: "", unitPrice: "", quantity: "", amount: "", unitCost: "", discount: "", doNotOrder: false, lockup: false },
        ],
      }));
    } else {  
      setInvoiceData((prevState) => ({ ...prevState, values }));
    }
    
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (invoice) {
      dispatch(
        updateInvoice(invoice._id, {
          ...invoiceData,
          subTotal: subTotal,
          total: total,
          salesTax: salesTax,
          rates: rates,
          dueDate: selectedDate,
          receivedByDate: selectedRbDate,
          client,
          type: type,
          status: status,
          deliveryFee: deliveryFee,
          deliveryCost: deliveryCost,
          deliveryFeeOverride: deliveryFeeOverride
        })
      );
      invoiceData.items.forEach((item, index) => {
        const originalItem = originalItems.current[index] || {
          lockup: false,
          doNotOrder: false,
          quantity: 0,
          modelNumber: "",
        };
        let l = lockups.find(obj => {
          if (item.lockup || originalItem.lockup) {
            if ((item.modelNumber === obj.modelNumber) || (originalItem.lockup === obj.modelNumber)) {
              return true;
            }
          }
        });
        if (l !== undefined) {
          if (originalItem.lockup === false) {
            l.quantity -= item.quantity;
          } else {
            if (originalItem.quantity < item.quantity) {
              l.quantity -= (item.quantity - originalItem.quantity)
            } else if (originalItem.quantity > item.quantity) {
              l.quantity += (originalItem.quantity - item.quantity)
            } else {
              if (item.lockup === false)
              {
                l.quantity += parseInt(item.quantity);
              } 
            }
          }
          dispatch(updateLockup(l._id, l, openSnackbar))
        }
        let inv = inventories.find(obj => {
          if (item.doNotOrder || originalItem.doNotOrder) {
            if ((item.modelNumber === obj.modelNumber) || (originalItem.doNotOrder === obj.modelNumber)) {
              return true;
            }
          }
        });
        if (inv !== undefined) {
          if (originalItem.doNotOrder === false) {
            inv.quantity -= item.quantity;
          } else {
            if (originalItem.quantity < item.quantity) {
              inv.quantity -= (item.quantity - originalItem.quantity)
            } else if (originalItem.quantity > item.quantity) {
              inv.quantity += (originalItem.quantity - item.quantity)
            } else {
              if (item.doNotOrder === false) {
                inv.quantity += item.quantity;
              }
              
            }
          }
          dispatch(updateInventory(inv._id, inv, openSnackbar))
        }
      })
      history.push(`/invoice/${invoice._id}`);
    } else {
      let createdInvoice = null;
      try {
        createdInvoice = await dispatch(
          createInvoice(
            {
              ...invoiceData,
              subTotal: subTotal,
              total: total,
              salesTax: salesTax,
              rates: rates,
              dueDate: selectedDate,
              receivedByDate: selectedRbDate,
              invoiceNumber: `${
                invoiceData.invoiceNumber < 100
                  ? Number(invoiceData.invoiceNumber).toString().padStart(3, "0")
                  : Number(invoiceData.invoiceNumber)
              }`,
              deliveryFee: deliveryFee,
              deliveryCost: deliveryCost,
              deliveryFeeOverride: deliveryFeeOverride,
              client,
              type: type,
              status: status,
              paymentRecords: [],
              creator: [user?.result?._id || user?.result?.googleId],
            },
            history
          )
        );
      } catch (error) {
        return;
      }
      if (quoteDraftQuoteIdRef.current && createdInvoice?._id) {
        try {
          await updateQuote(quoteDraftQuoteIdRef.current, {
            status: 'Converted',
            convertedInvoiceId: createdInvoice._id,
            convertedInvoiceNumber: createdInvoice.invoiceNumber,
            convertedAt: new Date().toISOString(),
          });
        } catch (error) {
          console.log(error);
        }
      }
      invoiceData.items.forEach(item => {
        let l = lockups.find(obj => {
          if (item.lockup) {
            if (item.modelNumber === obj.modelNumber) {
              return true;
            }
          }
        });
        if (l !== undefined) {
          l.quantity -= item.quantity;
          dispatch(updateLockup(l._id, l, openSnackbar))
        }
        let inv = inventories.find(obj => {
          if (item.doNotOrder) {
            if (item.modelNumber === obj.modelNumber) {
              return true;
            }
          }
        });
        if (inv !== undefined) {
          inv.quantity -= item.quantity;
          dispatch(updateInventory(inv._id, inv, openSnackbar))
        }
      })
    }

    // setInvoiceData(initialState)
  };

  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const CustomPaper = (props) => {
    return <Paper elevation={3} {...props} />;
  };

  if (!user) {
    history.push("/login");
  }

  return (
    <>
    <div className={styles.invoiceLayout}>
      <form onSubmit={handleSubmit} className="mu-form">
        <AddClient setOpen={setOpen} open={open} />
        <Container className={classes.headerContainer}>
          <Grid container justifyContent="space-between">
            <Grid item>
              {/* <Avatar alt="Logo" variant='square' src="" className={classes.large} /> */}
            </Grid>
            <Grid item>
              <InvoiceType type={type} setType={setType} />
              <div
                style={{
                  visibility: 'hidden',
                  marginTop: "15px",
                  width: "100px",
                  padding: "8px",
                  display: "inline-block",
                  backgroundColor: "#f4f4f4",
                  outline: "0px solid transparent",
                }}
                contenteditable="true"
                onInput={(e) =>
                  setInvoiceData({
                    ...invoiceData,
                    invoiceNumber: e.currentTarget.textContent,
                  })
                }
              >
                <span
                  style={{ width: "40px", color: "black", padding: "15px" }}
                  contenteditable="false"
                >
                  {" "}
                  {invoiceData.invoiceNumber}
                </span>
                <br />
              </div>
            </Grid>
          </Grid>
        </Container>
        <Divider />
        <Container>
          <Grid
            container
            justifyContent="space-between"
            style={{ marginTop: "40px" }}
          >
            <Grid item style={{ width: "50%" }}>
              <Container>
                <Typography
                  variant="overline"
                  style={{ color: "gray", paddingRight: "3px" }}
                  gutterBottom
                >
                  Bill to
                </Typography>

                {client && (
                  <>
                    <Typography variant="subtitle2" gutterBottom>
                      {client.store}
                    </Typography>
                    <Typography variant="body2">{client.email}</Typography>
                    <Typography variant="body2">{client.cellPhone}</Typography>
                    <Typography variant="body2">{client.address}</Typography>
                    <Button
                      color="primary"
                      size="small"
                      style={{ textTransform: "none" }}
                      onClick={() => handleClientChange(null)}
                    >
                      Change
                    </Button>
                  </>
                )}
                <div
                  style={client ? { display: "none" } : { display: "block" }}
                >
                  <Autocomplete
                    {...clientsProps}
                    PaperComponent={CustomPaper}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        required={!invoice && true}
                        label="Select Customer"
                        margin="normal"
                        variant="outlined"
                      />
                    )}
                    value={clients?.store}
                    onChange={(event, value) => handleClientChange(value)}
                  />
                </div>
                {!client && (
                  <>
                    <Grid item style={{ paddingBottom: "10px" }}>
                      <Chip
                        avatar={<Avatar>+</Avatar>}
                        label="New Customer"
                        onClick={() => setOpen(true)}
                        variant="outlined"
                      />
                    </Grid>
                  </>
                )}
              </Container>
            </Grid>

            <Grid item style={{ marginRight: 20, textAlign: "right" }}>
              <Typography
                variant="overline"
                style={{ color: "gray" }}
                gutterBottom
              >
                Status
              </Typography>
              <Typography
                variant="h6"
                gutterBottom
                style={{ color: type === "Receipt" ? "green" : "red" }}
              >
                {type === "Receipt" ? "Paid" : "Unpaid"}
              </Typography>
              <Typography
                variant="overline"
                style={{ color: "gray" }}
                gutterBottom
              >
                Date
              </Typography>
              <Typography variant="body2" gutterBottom>
              {selectedRbDate
                  ? moment(selectedRbDate).format("MMM Do YYYY")
                  : "27th Sep 2021"}
              </Typography>
              <Typography
                variant="overline"
                style={{ color: "gray" }}
                gutterBottom
              >
                Due Date
              </Typography>
              <Typography variant="body2" gutterBottom>
                {selectedDate
                  ? moment(selectedDate).format("MMM Do YYYY")
                  : "27th Sep 2021"}
              </Typography>
              <Typography variant="overline" gutterBottom>
                Amount
              </Typography>
              <Typography variant="h6" gutterBottom>
                ${toCommas(total)}
              </Typography>
            </Grid>
          </Grid>
        </Container>

        <div>
          <TableContainer component={Paper} className="tb-container">
            <Table className={classes.table} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Item</TableCell>
                  <TableCell>Qty</TableCell>
                  <TableCell>#</TableCell>
                  <TableCell>Cost ($)</TableCell>
                  <TableCell>Price ($)</TableCell>
                  {/* <TableCell>Disc (%)</TableCell> */}
                  <TableCell>Amount</TableCell>
                  <TableCell>Inv.</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {invoiceData.items.map((itemField, index) => (
                  <TableRow key={index}>
                    <TableCell scope="row" style={{ width: "40%" }}>
                      {" "}
                      {itemField.modelNumber && (
	                        <>
	                            <Typography variant="subtitle1" gutterBottom>
	                                {itemField.modelNumber}
	                            </Typography>
                              {renderPcLookupSummary(itemField.modelNumber)}
	                        </>
                        )}
                        <div style={itemField.modelNumber ? { display: "none" } : { display: "block" }}>
                        <Autocomplete
                            options={products.sort((a, b) => {
                            if (
                                a.hasOwnProperty("brand") &&
                                b.hasOwnProperty("brand")
                            ) {
                                return -b.brand.localeCompare(a.brand);
                            }
                            })}
                            groupBy={(option) => option.brand}
                            getOptionLabel={(option) => option.modelNumber || ""}
                            PaperComponent={CustomPaper}
                            renderInput={(params) => (
                            <TextField
                                {...params}
                                name="product"
                                label="Select Product"
                                margin="normal"
                                variant="outlined"
                            />
                            )}
                            value={itemField.modelNumber}
                            onChange={(e, value) => handleProductChange(index, e, value)}
                        />
                        </div>
                      {" "}
                    </TableCell>
                    <TableCell align="right">
                      {" "}
                      <InputBase
                        sx={{ ml: 1, flex: 1 }}
                        type="number"
                        name="quantity"
                        onChange={(e) => handleChange(index, e)}
                        onBlur={(e) => handleQuantityChange(index, e)}
                        value={itemField.quantity}
                        placeholder="0"
                      />{" "}
                    </TableCell>
                    <TableCell align="right">
                    {" "}
                      <FormGroup>
                        <FormControlLabel control={
                          <Checkbox
                            name="lockup"
                            checked={itemField.lockup}
                              color="primary"
                              onChange={(e) => handleLockupClick(index, e)}
                          />} label="" />
                      </FormGroup>{" "}
                    </TableCell>
                    <TableCell align="right">
                      {" "}
                      <InputBase
                        sx={{ ml: 1, flex: 1 }}
                        type="number"
                        name="unitCost"
                        onChange={(e) => handleChange(index, e)}
                        value={itemField.unitCost}
                        placeholder="0"
                      />{" "}
                    </TableCell>
                    <TableCell align="right">
                      {" "}
                      <InputBase
                        sx={{ ml: 1, flex: 1 }}
                        type="number"
                        name="unitPrice"
                        onChange={(e) => handleChange(index, e)}
                        value={itemField.unitPrice}
                        placeholder="0"
                      />{" "}
                    </TableCell>
                    {/* <TableCell align="right">
                      {" "}
                      <InputBase
                        sx={{ ml: 1, flex: 1 }}
                        type="number"
                        name="discount"
                        onChange={(e) => handleChange(index, e)}
                        value={itemField.discount}
                        placeholder="0"
                      />{" "}
                    </TableCell> */}
                    <TableCell align="right">
                      {" "}
                      <InputBase
                        sx={{ ml: 1, flex: 1 }}
                        type="number"
                        name="amount"
                        onChange={(e) => handleChange(index, e)}
                        value={
                          (itemField.quantity * itemField.unitPrice -
                          (itemField.quantity *
                            itemField.unitPrice *
                            itemField.discount) /
                            100).toFixed(2)
                        }
                        disabled
                      />{" "}
                    </TableCell>
                    <TableCell align="right">
                    {" "}
                      <FormGroup>
                        <FormControlLabel control={
                          <Checkbox
                            name="doNotOrder"
                            checked={itemField.doNotOrder}
                              color="primary"
                              onChange={(e) => handleDoNotOrderClick(index, e)}
                          />} label="" />
                      </FormGroup>{" "}
                    </TableCell>
                    <TableCell align="right">
                      <IconButton onClick={() => handleRemoveField(index)}>
                        <DeleteOutlineRoundedIcon
                          style={{ width: "20px", height: "20px" }}
                        />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <div className={styles.addButton}>
            <button className={styles.plusButton} onClick={handleAddField}>+</button>
            <Button
              color="primary"
              size="small"
              variant="outlined"
              style={{ marginLeft: 8, textTransform: 'none' }}
              onClick={() => setProductModalOpen(true)}
            >
              Add Product
            </Button>
          </div>
        </div>

        <div className={styles.summaryRow}>
          {renderScheduledOnOrderTable()}
          <div className={styles.invoiceSummary}>
            <div className={styles.summary}>Invoice Summary</div>
            <div className={styles.summaryItem}>
              <p>Sub total:</p>
              <h4>${(subTotal).toFixed(2)}</h4>
            </div>
            <div className={styles.summaryItem}>
              <p>Sales Tax:</p>
              <h4>${(salesTax).toFixed(2)}</h4>
            </div>
            <div className={styles.summaryItem}>
              <p>Delivery Fee:</p>
              <h4>${(deliveryFee).toFixed(2)}</h4>
            </div>
            <div className={styles.summaryItem}>
              <p>Total</p>
              <h4 style={{ color: "black", fontSize: "18px", lineHeight: "8px" }}>
                 ${toCommas(total.toFixed(2))}
              </h4>
            </div>
          </div>
        </div>

        <div className={styles.toolBar}>
          <Container>
            <Grid container>
              <Grid item style={{ marginTop: "16px", marginRight: 10 }}>
                <TextField
                  type="text"
                  step="any"
                  name="rates"
                  id="rates"
                  value={rates}
                  onChange={handleRates}
                  placeholder="e.g 10"
                  label="Tax Rates(%)"
                />
              </Grid>
              <Grid item style={{ marginTop: "16px", marginRight: 10 }}>
                <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                  <TextField
                    type="text"
                    step="any"
                    name="delivery"
                    id="delivery"
                    value={deliveryFee}
                    onChange={handleDeliveryFeeChange}
                    label="Delivery Fee ($)"
                  />
                  <TextField
                    type="text"
                    step="any"
                    name="deliveryCost"
                    id="deliveryCost"
                    value={deliveryCost}
                    onChange={handleDeliveryCostChange}
                    label="Delivery Cost ($)"
                    disabled={!deliveryFeeOverride}
                  />
                </div>
              </Grid>
              <Grid item style={{ marginTop: "30px", marginRight: 10 }}>
                <FormGroup>
                    <FormControlLabel control={<Checkbox
                              color="primary"
                              checked={deliveryFeeOverride}
                              onChange={handleDeliveryFeeOverride}
                          />} label="Fee Override" />
                  </FormGroup>
              </Grid>
              <Grid item style={{ marginRight: 10 }}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    margin="normal"
                    id="date-picker-dialog"
                    label="Received By Date"
                    format="MM/dd/yyyy"
                    value={selectedRbDate}
                    onChange={handleRbDateChange}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item style={{ marginRight: 10 }}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    margin="normal"
                    id="date-picker-dialog"
                    label="Due date"
                    format="MM/dd/yyyy"
                    value={selectedDate}
                    onChange={handleDateChange}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
            </Grid>
          </Container>
        </div>
        <div className={styles.note}>
          <h4>Note/Payment Info</h4>
          <textarea
            style={{ border: "solid 1px #d6d6d6", padding: "10px" }}
            placeholder="Provide additional details or terms of service"
            onChange={(e) =>
              setInvoiceData({ ...invoiceData, notes: e.target.value })
            }
            value={invoiceData.notes}
          />
        </div>

        {/* <button className={styles.submitButton} type="submit">Save and continue</button> */}
        <Grid container justifyContent="center">
          <Button
            id="save-invoice"
            variant="contained"
            style={{ justifyContentContent: "center" }}
            type="submit"
            color="primary"
            size="large"
            className={classes.button}
            startIcon={<SaveIcon />}
          >
            Save and Continue
          </Button>
        </Grid>
      </form>
    </div>
    <AddProduct
      open={productModalOpen}
      setOpen={setProductModalOpen}
      currentId={productCurrentId}
      setCurrentId={setProductCurrentId}
      onSaved={handleProductSaved}
    />
    </>
  );
};

export default Invoice;
